import Model from "../Model";
import ValidatableObject from "./ValidatableObject";

export interface TFormInputValueValidationError {
  formAttributeId?: number;
  messageTranslationCode?: string;
  message?: string;
  formSectionId?: number;
  formQualifierId?: number;
}

export interface IFormInputValueValidationError
  extends TFormInputValueValidationError {}

const FormInputValueValidationError = Model(
  (model: TFormInputValueValidationError): IFormInputValueValidationError => {
    const _formInputValueValidationError: TFormInputValueValidationError = Object.assign(
      {},
      model
    );

    let create = (
      formInputValueValidationError: IFormInputValueValidationError
    ): IFormInputValueValidationError => {
      let obj = ValidatableObject(formInputValueValidationError);

      return obj;
    };

    let FormInputValueValidationError = {
      get formAttributeId() {
        return _formInputValueValidationError.formAttributeId;
      },
      set formAttributeId(value) {
        _formInputValueValidationError.formAttributeId = value;
      },
      get messageTranslationCode() {
        return _formInputValueValidationError.messageTranslationCode;
      },
      set messageTranslationCode(value) {
        _formInputValueValidationError.messageTranslationCode = value;
      },
      get formSectionId() {
        return _formInputValueValidationError.formSectionId;
      },
      set formSectionId(value) {
        _formInputValueValidationError.formSectionId = value;
      },
      set formQualifierId(value) {
        _formInputValueValidationError.formQualifierId = value;
      },
      get formQualifierId() {
        return _formInputValueValidationError.formQualifierId;
      },
      get message() {
        return _formInputValueValidationError.message;
      },
      set message(value) {
        _formInputValueValidationError.message = value;
      }
    };
    return create(FormInputValueValidationError);
  }
);

export default FormInputValueValidationError;
